<!--toggle: bg-white|bg-primary|bg-info|bg-warning|bg-dark|bg-success|bg-danger|bg-secondary------>
<header class="app-header navbar bg-dark"> <!--when dark-blue theme is called bg-dark class will apply-->

  <a class="navbar-brand" style="color:#fff;">
    Astute Services <!-- <img src="/assets/img/brand/Astute1.jpg" style="width:40px;"/>  -->
  </a>

  <button id="left-toggle" type="button" class="navbar-toggler">
    <span class="navbar-toggler-icon"></span>
  </button>

  <ul class="nav navbar-nav d-md-down-none mr-auto">
    <li class="nav-item">
      <a class="nav-link" style="padding-left:5px;">{{common.pageTitle ? common.pageTitle: ''}}</a>
    </li> <!--{{common.pageTitle ? common.pageTitle: ''}}-->
  </ul>


  <!------Right side menu.--------->
  <ul class="nav navbar-nav ml-auto right-menu-option">

    <!-- <li class="nav-item d-md-down-none">
      <button type="button" [disabled]="disableActions" class="btn btn-info btn-shadow btn-sm my-0 py-1 mx-1" title="Upload ITR Copy"
        [class.active-highlight]="activeButton === 'uploadZip'" style="font-size: 9px !important;"  
        (click)="uploadZipFileModal('ITRCopyZip', 'process/upload/processITRZip')">
        <i class="fa fa-solid fa-cloud-arrow-up"></i> Upload ITR ZIP/RAR/PDF Copy
      </button>
    </li> -->


    <!-- <li class="nav-item d-md-down-none">
       <button type="button" [disabled]="disableActions" class="btn btn-info btn-shadow btn-sm my-0 py-1 mx-1"
        [class.active-highlight]="activeButton === 'pendingList'" style="font-size: 9px !important;"  (click)="pendingITRList()">
        <i class="fa fa-solid fa-list"></i> Pending ITR List
      </button> 
    </li> -->

    <!-- <li class="nav-item d-md-down-none">
      <button type="button" [disabled]="disableActions" class="btn btn-info btn-shadow btn-sm my-0 py-1 mx-1"
        [class.active-highlight]="activeButton === 'annualTax'" style="font-size: 9px !important;" 
        (click)="goToAnnualTax()"><i class="fa fa-solid fa-cloud-arrow-up"></i> Process 26-AS
      </button>
    </li> -->

    <!-- <li class="nav-item d-md-down-none">
      <button type="button" [disabled]="disableActions" class="btn btn-info btn-shadow btn-sm my-0 py-1 mx-1" title="Financial Statement"
        [class.active-highlight]="activeButton === 'uploadFinancial'" style="font-size: 9px !important;" 
        (click)="openUploadITRFileModal()"><i class="fa fa-solid fa-cloud-arrow-up"></i> Process Financial ITR
      </button>
    </li>  -->

    <li class="nav-item d-md-down-none"
        [class.nav-item-disabled]="isItrButtonDisabled"
        [attr.title]="isItrButtonDisabled ? (activeWorkflowLabel + ' workflow is active — please save or reset it before switching.') : null">
      <button type="button" class="btn btn-info btn-shadow btn-sm my-0 py-1 mx-1"
        [routerLink]="['/process-physical-ITR']"
        routerLinkActive="active-highlight"
        [disabled]="isItrButtonDisabled">
        <i class="fa-solid fa-boxes-stacked mr-1"></i> Process ITR
      </button>
    </li>

    <li class="nav-item d-md-down-none">
      <button type="button" class="btn btn-info btn-shadow btn-sm my-0 py-1 mx-1"
        [routerLink]="['/pending-ITR-list']"
        routerLinkActive="active-highlight">
        <i class="fa fa-solid fa-list mr-1"></i> Pending ITR List
      </button>
    </li>

    <li class="nav-item d-md-down-none"
        [class.nav-item-disabled]="is26ASButtonDisabled"
        [attr.title]="is26ASButtonDisabled ? (activeWorkflowLabel + ' workflow is active — please save or reset it before switching.') : null">
      <button type="button" class="btn btn-info btn-shadow btn-sm my-0 py-1 mx-1"
        [routerLink]="['/process-form-26-AS']"
        routerLinkActive="active-highlight"
        [disabled]="is26ASButtonDisabled">
        <i class="fa-solid fa-file-invoice-dollar mr-1"></i> Process 26-AS
      </button>
    </li>

    <li class="nav-item d-md-down-none"
        [class.nav-item-disabled]="isFinancialButtonDisabled"
        [attr.title]="isFinancialButtonDisabled ? (activeWorkflowLabel + ' workflow is active — please save or reset it before switching.') : null">
      <button type="button" class="btn btn-info btn-shadow btn-sm my-0 py-1 mx-1"
        [routerLink]="['/process-financial-statement']"
        routerLinkActive="active-highlight"
        [disabled]="isFinancialButtonDisabled">
        <i class="fa-solid fa-chart-pie mr-1"></i> Process Financial
      </button>
    </li>

  </ul>

  <!-- <div class="toggle-icons"> -->
  <!-- <span class="column-view"><i class="fa fa-solid fa-table-columns"></i></span>
      <span class="row-view"><i class="fa fa-solid fa-list"></i></span> -->
  <!-- <div class="btn-group" role="group" aria-label="Basic example">
      <button type="button" [class]="vClass" title="Vertical view" (click)="toggleView('V')"><i class="fa fa-solid fa-table-columns"></i></button>
      <button type="button" [class]="hClass" title="Horizontal view" (click)="toggleView('H')"><i class="fa fa-solid fa-list"></i></button>
    </div>  
  </div> -->

  <!--new-->
  <!-- <div class="notification-bell-dropdown mr-2" ngbDropdown>
    <button class="btn" id="notification" ngbDropdownToggle>
      <span class="bell-icon"><i class="fa far fa-bell" style="font-size: 20px;"></i></span>
      <span class="badge badge-primary">99+</span>
    </button>
    <div class="dropdown-submenu noti-submenu" ngbDropdownMenu="notification">
        <div class="dropdown-header noti-title">
           <h4 class="noti-title-h4">Notification</h4>
           <a class="clear-all" href="javascript:void(0);">Clear All</a>
        </div>
        <div class="dropdown-body">
           <ul class="timeline">
              <li>
                  <div class="message-icon-img">
                    <span>
                        <img class="img-fluid" src="../../../assets/img/avatars/9.jpg" />
                    </span>
                  </div>
                  <div class="message-body">
                        <h4>Cristina Pride</h4>
                        <p class="text-muted mb-0"><small>Hi, How are you? What about our next meeting</small></p>
                  </div>
              </li>
              <li>
                <div class="message-icon-img">
                  <span><i class="fa far fa-bell"></i></span>
                </div>
                <div class="message-body">
                      <h4>Caleb Flakelar commented on Admin</h4>
                      <p class="text-muted mb-0"><small>Hi, How are you? What about our next meeting</small></p>
                </div>
              </li>
              <li>
                <div class="message-icon-img">
                  <span><i class="fa far fa-bell"></i></span>
                </div>
                <div class="message-body">
                  <h4>Caleb Flakelar commented on Admin</h4>
                  <p class="text-muted mb-0"><small>Hi, How are you? What about our next meeting</small></p>
                </div>
              </li>
              <li>
                <div class="message-icon-img">
                  <span><i class="fa far fa-bell"></i></span>
                </div>
                <div class="message-body">
                    <h4>Caleb Flakelar commented on Admin</h4>
                    <p class="text-muted mb-0"><small>Hi, How are you? What about our next meeting</small></p>
                </div>
              </li>
           </ul>
        </div>
        <div class="dropdown-footer">
           <a class="view-all-link" href="javascript:void(0);">View All <i class="far fa-arrow-alt-circle-right"></i></a>
        </div>
    </div>
  </div> -->

  <div class="user-login-name-dropdown ml-2" ngbDropdown>
    <button class="btn" id="userloginname" ngbDropdownToggle>
      <!-- <img src="https://github.com/mdo.png" alt="mdo" width="25" height="25" class="img-avatar mr-1 rounded-circle"> -->
      <span class="initial-user-name">{{ getInitials(username) }}</span>
      <span style="padding:0px 5px;">{{ username }}</span>
    </button>
    <div class="dropdown-submenu" ngbDropdownMenu="userloginname">
      <div class="dropdown-header noti-title">
        <h6 class="text-overflow m-0">Welcome!</h6>
      </div>
      <button class="sub-menu" ngbDropdownItem routerLink="/profile" style="display: none;"><i
          class="fa far fa-user mr-1"></i> My Account</button>
      <button class="sub-menu" ngbDropdownItem style="display: none;" (click)="changePassword()"><i
          class="fa fas fa-unlock-alt mr-1"></i> Change
        Password</button><!---->
      <button class="sub-menu" ngbDropdownItem (click)="logout()"><i class="fa fas fa-sign-out-alt mr-1"></i> Sign
        out</button> <!--(click)="logout()"-->
    </div>
  </div>
  <!------Right side menu.--------->

  <!--<button id="right-toggle" type="button" class="navbar-toggler right-toggler"><span class="fa fas fa-palette"></span></button>d-lg-block d-none-->

</header>




<div class="progress-overlay" *ngIf="showProgress">
  <div class="progress-card">
    <h5>Processing in progress</h5>
    <p>Please wait...</p>
    <p> {{ processedFiles }} / {{ totalFiles }}</p>
    <div class="progress">
      <div class="progress-bar" role="progressbar" [style.width.%]="progress" aria-valuemin="0" aria-valuemax="100">
        {{ progress }}%
      </div>
    </div>
  </div>
</div>